import { ProcessDocumentCrmo } from 'domain/usecases/surgical-order/process-document-crmo'
import { SurgicalOrderRepository } from 'repository/interfaces/surgical-order-repository'

export class RemoteProcessDocumentCrmo implements ProcessDocumentCrmo {
  constructor(
    private readonly surgicalOrderRepository: SurgicalOrderRepository
  ) {}

  process(
    params: ProcessDocumentCrmo.Params
  ): Promise<ProcessDocumentCrmo.Model> {
    return this.surgicalOrderRepository.processDocumentCrmo(params)
  }
}
